"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * also limit users by
 * limit on course participation ends by
 */
var RedemptionLimitTypes;
(function (RedemptionLimitTypes) {
    RedemptionLimitTypes["enrolleeCompany"] = "enrolleeCompany";
    RedemptionLimitTypes["enrolleeDepartment"] = "enrolleeDepartment";
    RedemptionLimitTypes["enrolleeLevel"] = "enrolleeLevel";
    RedemptionLimitTypes["enrolleeLocation"] = "enrolleeLocation";
    RedemptionLimitTypes["enrolleePractice"] = "enrolleePractice";
    RedemptionLimitTypes["enrolleeProfileId"] = "enrolleeProfileId";
    RedemptionLimitTypes["enrolleeRequiresAdminPermission"] = "enrolleeRequiresAdminPermission";
    RedemptionLimitTypes["enrollmentTargetDate"] = "enrollmentTargetDate";
    RedemptionLimitTypes["enrollmentTargetDeliveryMethod"] = "enrollmentTargetDeliveryMethod";
    RedemptionLimitTypes["enrollmentTarget"] = "enrollmentTarget";
    RedemptionLimitTypes["enrollmentTargetVendor"] = "enrollmentTargetVendor";
    RedemptionLimitTypes["redemptionDate"] = "redemptionDate";
    RedemptionLimitTypes["redemptionHours"] = "redemptionHours";
    RedemptionLimitTypes["redemptionQuantity"] = "redemptionQuantity";
})(RedemptionLimitTypes = exports.RedemptionLimitTypes || (exports.RedemptionLimitTypes = {}));
//# sourceMappingURL=redemptionLimitTypes.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@prolaera/types/dist/enums/redemptionLimitTypes.js
// module id = 879
// module chunks = 0